import { print } from 'graphql'
import { Cart } from 'shopify-types'

import { storefrontClient } from '..'
import {
  UpdateCartDiscountCodesDocument,
  type UpdateCartDiscountCodesMutation,
} from '../__generated/storefront'
import { GlobalRequestOptions } from '../types'
import { mapGQLCartToCart } from './graphql'

export const applyDiscount =
  (options: GlobalRequestOptions) =>
  async (cartId: string, discountCodes: string[]): Promise<Cart> => {
    const response = await storefrontClient.request<UpdateCartDiscountCodesMutation>(
      print(UpdateCartDiscountCodesDocument),
      {
        variables: {
          cartId,
          discountCodes,
          language: options.language,
        },
      },
    )

    const payload = response.data?.cartDiscountCodesUpdate

    if (!payload?.cart) {
      throw new Error('Failed to apply discount code')
    }

    return mapGQLCartToCart(payload.cart)
  }
